var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTimes(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 9,
    height: 9,
    viewBox: "0 0 9 9",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "times"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M5.60851 4.507L8.80213 1.31337C8.85537 1.26376 8.89808 1.20393 8.9277 1.13746C8.95732 1.07099 8.97324 0.999227 8.97453 0.926465C8.97581 0.853703 8.96243 0.781428 8.93517 0.713951C8.90792 0.646475 8.86735 0.585179 8.81589 0.533721C8.76443 0.482262 8.70314 0.441695 8.63566 0.41444C8.56818 0.387186 8.49591 0.373801 8.42314 0.375084C8.35038 0.376368 8.27862 0.392294 8.21215 0.421913C8.14568 0.451531 8.08585 0.494235 8.03624 0.547476L4.84261 3.7411L1.64898 0.547476C1.54626 0.451754 1.41039 0.399642 1.27 0.402119C1.12961 0.404596 0.995657 0.461469 0.89637 0.560755C0.797084 0.660042 0.740211 0.79399 0.737734 0.934381C0.735257 1.07477 0.787369 1.21064 0.883091 1.31337L4.07672 4.507L0.883091 7.70062C0.78161 7.80223 0.724609 7.93997 0.724609 8.08357C0.724609 8.22718 0.78161 8.36491 0.883091 8.46652C0.984699 8.568 1.12243 8.625 1.26604 8.625C1.40964 8.625 1.54738 8.568 1.64898 8.46652L4.84261 5.27289L8.03624 8.46652C8.13785 8.568 8.27558 8.625 8.41919 8.625C8.56279 8.625 8.70053 8.568 8.80213 8.46652C8.90361 8.36491 8.96062 8.22718 8.96062 8.08357C8.96062 7.93997 8.90361 7.80223 8.80213 7.70062L5.60851 4.507Z",
    fill: "#FF3D32"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTimes);
export default __webpack_public_path__ + "static/media/times.ce606b325a34dcb330984029de6f7b66.svg";
export { ForwardRef as ReactComponent };